export default "__VITE_PUBLIC_ASSET__56950b87__"